import { useQuery } from '@tanstack/react-query';
import { Device } from '@ixicare/resources';
import { useStores } from '~store/utils';
import { LOW_BATT_THRESHOLD } from '~modules/devices/utils/constants';

export function useLowBatteryDevices() {
  const { sites } = useStores();
  const siteUuid = sites.selectedSite?.uuid;
  const { data } = useQuery({
    queryKey: ['low-battery-devices', siteUuid],
    queryFn: () =>
      Device.getLowBatteryDevices({
        site: siteUuid!,
        threshold: LOW_BATT_THRESHOLD,
      }),
    enabled: !!siteUuid,
  });
  return data;
}
